import styled from 'styled-components';
import tw, { css } from 'twin.macro';

export const TimesheetBottomActionBar = styled.div(() => [
  tw`border-t border-silver-base bg-white py-8 px-4`,
  css`
    padding-bottom: calc(0.5rem + env(safe-area-inset-bottom));
  `
]);

export const TimesheetContentWrapper = styled.div(({ $borderTop }) => [
  tw`bg-white mb-8 border-b border-silver-lighten-15`,
  $borderTop && tw`border-t`
]);

export default TimesheetBottomActionBar;
